import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { logout } from '../services/api';
import { useUser } from '../contexts/UserContext';
import { useTutorialVideos } from '../contexts/TutorialVideoContext';

/**
 * PausedScreen
 *
 * The offline notice shown in place of the whole app (no navbar, no mobile
 * bottom bar) to anyone whose tier has App Access off in
 * Roles -> Feature Matrix, and to new people turned away while sign-up is
 * closed. Admins never see it. See docs/handoff_scaledown_stocktimus_app.md.
 *
 * Signed in: a Log out button. Signed out: a link back to the sign-in page.
 */
function PausedScreen({ onLogout }) {
  const navigate = useNavigate();
  const { user, clearUser } = useUser();
  const { clearVideos } = useTutorialVideos();
  const signedIn = !!user || !!localStorage.getItem('token');

  // Same steps as Navbar's logout, plus App's handler so isLoggedIn resets
  const handleLogout = () => {
    logout();
    clearUser();
    clearVideos();
    onLogout?.();
    navigate('/login');
  };

  return (
    <div className="dark bg-background text-text min-h-screen flex items-center justify-center px-4 py-12">
      <div className="w-full max-w-md bg-surface rounded-lg shadow-lg p-8 border border-muted text-center space-y-6">
        <img
          src="/logo/logo_navbar-dark.svg"
          alt="Options Leveling"
          className="h-10 w-auto mx-auto"
        />

        <h1 className="text-2xl font-bold text-brand-white">
          Options Leveling is stepping back.
        </h1>

        <p className="text-brand-gray-blue leading-relaxed">
          I've taken the product offline for now. My focus is on personal algorithmic trading.
          If this ever opens back up to the public, I'll post it on optionsleveling.com.
        </p>

        {signedIn ? (
          <button
            type="button"
            onClick={handleLogout}
            className="w-full bg-brand-blue text-white font-semibold py-3 rounded-lg hover:bg-[#1a7aef] transition-colors"
          >
            Log out
          </button>
        ) : (
          <Link
            to="/login"
            className="inline-block text-sm text-brand-blue hover:text-[#1a7aef] transition-colors"
          >
            Back to sign in
          </Link>
        )}
      </div>
    </div>
  );
}

export default PausedScreen;
